<div class="form-control">
  <label class="input" [class.input--invalid]="errorMessage()">
    @if (label()) {
      <span [class]="'input__label ' + (control().touched ? 'text-neutral-900' : 'text-neutral-700')">
        {{ label() }}
      </span>
    }
    <input
      [attr.id]="inputId()"
      [attr.name]="inputId()"
      [type]="type()"
      [formControl]="control()"
      [placeholder]="placeholder()"
      [required]="required()"
      [pattern]="pattern()"
      (blur)="onBlur($event)"
      [readonly]="readonly()"
      [min]="min()"
      [max]="max()"
      [attr.inputmode]="inputmode()"
      class="input__control"
      [attr.aria-describedby]="ariaDescribedBy()"
      [attr.aria-invalid]="errorMessage() ? 'true' : 'false'"
      (keypress)="onKeyPress($event)"
    />
  </label>

  <div [attr.id]="messageId()" [class]="'form-help ' + (control().touched ? 'text-neutral-900' : 'text-neutral-700')" aria-live="polite" aria-atomic="true">
    @if (!errorMessage() && helpText()) {
      <ng-container>
        {{ helpText() }}
      </ng-container>
    }
    @if (errorMessage()) {
      <div data-testid="error-message" class="error-message form-help--invalid flex items-center gap-100" [attr.id]="errorId()">
        <ng-icon name="lucideCircleAlert" class="!overflow-visible" aria-hidden="true"></ng-icon>

        <ng-container *ngTemplateOutlet="customErrorTemplate || defaultErrorMessage; context: { $implicit: errorMessage() }"></ng-container>

        <ng-template #defaultErrorMessage>
          {{ errorMessage() }}
        </ng-template>
      </div>
    }
  </div>
</div>
